import { buildOrganizationsQueryParams } from '@gasbi/shared/common/features/organizations/utils';
import { CONTEXT_ORGANIZATION_ID_CACHE_KEY } from '@gasbi/shared/common/providers/OrganizationProvider';
import OrganizationManager from '@gasbi/shared/common/utils/organizationManager';
import { appEventBus } from '@gasbi/shared/web/utils/appEventBus';
import { AppEvents } from '@gasbi/shared/web/utils/appEventBus/eventMap';
import { Navigate } from 'react-router-dom';

import { useGetOrganizationsInfiniteQuery } from '@/features/organizations/organizationsApi';
import Pages from '@/pages';

const NOT_AUTHORIZED_ERROR_CODES = [403];

// Cookie (BFF) landing for "/" (and the old /callback link): deep links come
// back through the BFF's returnUrl, so this page only picks the context
// organization - the session's one (GSB-8274), or, without the session endpoint,
// the last used one if it is still available, else the first.
const AuthCallback = () => {
  const { data, error, isLoading } = useGetOrganizationsInfiniteQuery(
    buildOrganizationsQueryParams(),
    {
      infiniteQueryOptions: { pageSize: 100 },
    },
  );

  if (isLoading) {
    return null;
  }

  if (NOT_AUTHORIZED_ERROR_CODES.includes(error?.status)) {
    appEventBus.emit(AppEvents.LoadingStateEvent, false);
    return <Navigate to={Pages.NOT_AUTHORIZED} replace />;
  }

  if (error) {
    return <Navigate to={Pages.NO_PERMISSIONS} replace />;
  }

  if (!data || data.length === 0) {
    appEventBus.emit(AppEvents.LoadingStateEvent, false);
    return <Navigate to={Pages.NOT_AUTHORIZED} replace />;
  }

  // The server chose the organization (last chosen → head office → first by name), PO 2026-10-25.
  const activeOrganizationId = OrganizationManager.getActiveOrganizationId();

  if (activeOrganizationId) {
    return <Navigate to={`/${activeOrganizationId}`} replace />;
  }

  const cachedOrgId = localStorage.getItem(CONTEXT_ORGANIZATION_ID_CACHE_KEY);
  const contextOrgId =
    data.find(org => org.id === cachedOrgId)?.id || data[0].id;

  return <Navigate to={`/${contextOrgId}`} replace />;
};

export default AuthCallback;
